// extracted by mini-css-extract-plugin
module.exports = {"root":"ClientCreditCards_root__xqXKE","cards":"ClientCreditCards_cards__223Qg","empty":"ClientCreditCards_empty__1N407"};